/*
  PARCHE NEW ERA (velocidad, 04/11) — «Mas para elegir» (sections/recomendaciones-dan), diferido.

  En /products/... la seccion deja un esqueleto. Cuando el cliente se acerca bajando, este
  elemento pide la MISMA seccion desde /collections/all/products/...?section_id=..., donde
  si se calculan los embudos de Daniel, y la pone en su lugar. Quien no baja hasta ahi no la
  calcula nunca.
*/
(() => {
  const MARGEN = '600px 0px';

  class RecomendacionesDiferidas extends HTMLElement {
    connectedCallback() {
      if (this.observador || this.iniciado) return;
      if (!('IntersectionObserver' in window)) {
        this.cargar();
        return;
      }
      this.observador = new IntersectionObserver((entradas) => {
        if (entradas.some((e) => e.isIntersecting)) this.cargar();
      }, { rootMargin: MARGEN });
      this.observador.observe(this);
    }

    disconnectedCallback() {
      if (this.observador) this.observador.disconnect();
      this.observador = null;
    }

    cargar() {
      if (this.iniciado) return;
      this.iniciado = true;
      if (this.observador) this.observador.disconnect();
      fetch(this.dataset.url)
        .then((r) => {
          if (!r.ok) throw new Error(`HTTP ${r.status}`);
          return r.text();
        })
        .then((html) => this.pintar(html))
        .catch(() => this.vaciar());
    }

    pintar(html) {
      if (!this.isConnected) return;
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const seccion = tmp.querySelector('.shopify-section') || tmp;
      // Si vuelve el esqueleto (o nada), no hay recomendaciones que pintar.
      if (!seccion.querySelector('.collection-slider-row .product-block') || seccion.querySelector('recomendaciones-diferidas')) {
        this.vaciar();
        return;
      }
      this.replaceWith(...seccion.childNodes);
    }

    vaciar() {
      if (!this.isConnected) return;
      this.replaceChildren();
      this.removeAttribute('aria-busy');
      this.hidden = true;
    }
  }

  if (!customElements.get('recomendaciones-diferidas')) {
    customElements.define('recomendaciones-diferidas', RecomendacionesDiferidas);
  }
})();
